import { useEffect } from "react";
import PropTypes from "prop-types";
import Title from "../Title";
import CustomerItems from "../../../containers/customerItems/CustomerItems";
import SavedItems from "../../../containers/common/SavedItems";
import { useUrlContext } from "../../../containers/common/UrlProvider";
import { mapDisplaySortToState } from "../../../../savedItemsSortConfig";
import Banners from "../Banners";

const EntryPoint = ({ initialise, ...rest }) => {
  const {
    searchParams: { sort }
  } = useUrlContext();
  useEffect(() => {
    const sortOption = mapDisplaySortToState(sort);
    initialise({ sortOption });
  }, []);

  return (
    <SavedItems
      TitleComponent={Title}
      ItemsComponent={CustomerItems}
      BannersComponent={Banners}
      {...rest}
    />
  );
};

EntryPoint.propTypes = {
  initialise: PropTypes.func.isRequired
};

export default EntryPoint;
